function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-build_svg__linear-gradient",
  x1: 50,
  y1: 94.79,
  x2: 50,
  y2: 64.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-build_svg__linear-gradient-2",
  x1: 30.71,
  y1: 2.46,
  x2: 108.25,
  y2: 155.46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-build_svg__linear-gradient-3",
  x1: 66.67,
  y1: 53.93,
  x2: 0.13,
  y2: 10.31,
  xlinkHref: "#2-build_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2-build_svg__linear-gradient-4",
  x1: 75.87,
  y1: 48.26,
  x2: 86.48,
  y2: 6.16,
  xlinkHref: "#2-build_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("style", null, ".2-build_svg__cls-4{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "2-build_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "2-build_svg__Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 66h100v6a4 4 0 01-4 4H4a4 4 0 01-4-4v-6z",
  fill: "url(#2-build_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90 66H10V16a4 4 0 014-4h72a4 4 0 014 4z",
  fill: "url(#2-build_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#2-build_svg__linear-gradient-3)",
  d: "M18 20h64v46H18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "2-build_svg__cls-4",
  d: "M30 30h40v4H30zm0 9h40v4H30zm0 9h28v4H30z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 68,
  width: 32,
  height: 32,
  rx: 16,
  fill: "url(#2-build_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  className: "2-build_svg__cls-4",
  d: "M82.11 23.72l-7.05-7.05 2.71-2.71 4.34 4.34 8.58-8.58 2.71 2.71-11.29 11.29z"
})));

function Svg2Build(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 76"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTAwIDc2Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjUwIiB5MT0iOTQuNzkiIHgyPSI1MCIgeTI9IjY0LjA0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMjNjMzg2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODBlOGJiIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudC0yIiB4MT0iMzAuNzEiIHkxPSIyLjQ2IiB4Mj0iMTA4LjI1IiB5Mj0iMTU1LjQ2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMDA3NzYzIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjNjMzg2Ii8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudC0zIiB4MT0iNjYuNjciIHkxPSI1My45MyIgeDI9Ii4xMyIgeTI9IjEwLjMxIiB4bGluazpocmVmPSIjbGluZWFyLWdyYWRpZW50LTIiLz48bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudC00IiB4MT0iNzUuODciIHkxPSI0OC4yNiIgeDI9Ijg2LjQ4IiB5Mj0iNi4xNiIgeGxpbms6aHJlZj0iI2xpbmVhci1ncmFkaWVudCIvPjxzdHlsZT4uY2xzLTR7ZmlsbDojZmZmfTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8yLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PHBhdGggZD0iTTAgNjZoMTAwdjZhNCA0IDAgMDEtNCA0SDRhNCA0IDAgMDEtNC00di02eiIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+PHBhdGggZD0iTTkwIDY2SDEwVjE2YTQgNCAwIDAxNC00aDcyYTQgNCAwIDAxNCA0eiIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQtMikiLz48cGF0aCBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudC0zKSIgZD0iTTE4IDIwaDY0djQ2SDE4eiIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTMwIDMwaDQwdjRIMzB6TTMwIDM5aDQwdjRIMzB6TTMwIDQ4aDI4djRIMzB6Ii8+PHJlY3QgeD0iNjgiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgcng9IjE2IiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudC00KSIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTgyLjExIDIzLjcybC03LjA1LTcuMDUgMi43MS0yLjcxIDQuMzQgNC4zNCA4LjU4LTguNTggMi43MSAyLjcxLTExLjI5IDExLjI5eiIvPjwvZz48L2c+PC9zdmc+";
export { Svg2Build as ReactComponent };